export default "__VITE_ASSET__DPoghEf7__"